module.exports = __webpack_public_path__ + "img/chiken.45d89965.png";